import React, {Component} from 'react';
import {
    Input,
    Label,
    Row,
    Col,
    Popover,
    PopoverBody
} from 'reactstrap';
import _ from 'lodash';
import './PeriodSelect.css';

import PropTypes from 'prop-types';
import {
    AVAILABLE_CONSENT_PERIODS,
    AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST
} from "../../../constants/constants";
import Select from '../../commonComponents/customSelect/CustomSelect.container';

class PeriodSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isPopoverOpen: false
        }
    }

    setInput = (inputName) => (input) => {
        this[inputName] = input;
    };

    render() {
        let periodTypeSelectId = 'period-type-input' + (this.props.id ? this.props.id : '');
        let periodNumSelectId = 'period-number-input' + (this.props.id ? this.props.id : '');
        return (
            <div className={"period-select-container " + this.props.className}>
                <Row hidden={_.isNil(this.props.label)}>
                    <Col>
                        <Label className='period-label'>
                            {this.props.label}
                        </Label>
                    </Col>
                </Row>
                <Row>
                    <Col sm={3}
                         className="period-number-input-container">
                        <Input id={periodNumSelectId}
                               ref={this.setInput('numInput')}
                               type='number'
                               value={this.props.periodNum}
                               required
                               hidden={this.props.periodType === AVAILABLE_CONSENT_PERIODS.FOREVER}
                               onBlur={this.handlePopoverBlur}
                               onFocus={this.showPopover}
                               onChange={this.handlePeriodNumChange}/>
                    </Col>
                    <Col className="period-input-container"
                         id="period-input-container"
                         sm={9}>
                        <Select
                            id={periodTypeSelectId}
                            ref={this.setInput('typeInput')}
                            onBlur={this.handlePopoverBlur}
                            onFocus={this.showPopover}
                            onSelect={this.handlePeriodTypeChange}
                            selectedOption={this.getSelectedPeriodOption()}
                            options={this.getPeriodOptions()}
                        />
                        {this.renderPopover(periodTypeSelectId)}
                    </Col>
                </Row>
            </div>
        )
            ;
    }

    renderPopover = (target) => {
        if (!this.props.showPopover) {
            return null;
        }

        return (
            <Popover placement={this.props.placement || 'right'}
                     target={target}
                     isOpen={this.state.isPopoverOpen}
                     container='period-input-container'>
                <PopoverBody>
                    {this.props.periodEndDateMessage}
                </PopoverBody>
            </Popover>
        )
    };

    showPopover = () => {
        if (!this.state.isPopoverOpen) {
            this.setState({isPopoverOpen: true});
        }
    };

    hidePopover = () => {
        if (this.state.isPopoverOpen) {
            this.setState({isPopoverOpen: false})
        }
    };

    handlePopoverBlur = (e) => {
        let relatedTarget = e.relatedTarget;
        if (_.isNil(relatedTarget) || (relatedTarget.id !== this.numInput.props.id && relatedTarget.id !== this.typeInput.props.id)) {
            this.hidePopover();
        }
    };

    getSelectedPeriodOption = () => {
        return {
            value: this.props.periodType,
            label: _.get(this.props.translation, `consents.periods.${this.props.periodType}_label`)
        }
    };

    getPeriodOptions = () => {
        return _.map(AVAILABLE_CONSENT_PERIODS_TO_APPROVE_AFTER_REQUEST, period => ({
                value: period, label: _.get(this.props.translation, `consents.periods.${period}_label`)
            })
        );
    };

    handlePeriodTypeChange = (selectedOption) => {
        this.props.onPeriodTypeChange(selectedOption.value);
    };

    handlePeriodNumChange = (e) => {
        if (e.target.value > 0) {
            this.props.onPeriodNumChange(Math.floor(e.target.value).toString());
        }
    }
}

PeriodSelect.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    label: PropTypes.string,
    showPopover: PropTypes.bool,
    placement: PropTypes.string,
    periodEndDateMessage: PropTypes.string,
    periodType: PropTypes.string,
    periodNum: PropTypes.string,
    translation: PropTypes.object,
    onPeriodNumChange: PropTypes.func,
    onPeriodTypeChange: PropTypes.func
};

export default PeriodSelect;



// WEBPACK FOOTER //
// ./src/components/consentManagement/periodSelect/PeriodSelect.js